import { Form } from "@inertiajs/react"
import { useRef } from "react"

import HeadingSmall from "@/components/heading-small"
import InputError from "@/components/input-error"
import { Button, buttonVariants } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { usersPath } from "@/routes"

export default function DeleteUser() {
  const passwordInput = useRef<HTMLInputElement>(null)

  return (
    <div className="space-y-6">
      <HeadingSmall
        title="Delete account"
        description="Delete your account and all of its resources"
      />
      <div className="space-y-4 rounded-lg border border-red-100 bg-red-50 p-4 dark:border-red-200/10 dark:bg-red-700/10">
        <div className="relative space-y-0.5 text-red-600 dark:text-red-100">
          <p className="font-medium">Warning</p>
          <p className="text-sm">
            Please proceed with caution, this cannot be undone.
          </p>
        </div>

        <Dialog>
          <DialogTrigger className={buttonVariants({ variant: "destructive" })}>
            Delete account
          </DialogTrigger>
          <DialogContent>
            <DialogTitle>
              Are you sure you want to delete your account?
            </DialogTitle>
            <DialogDescription>
              Once your account is deleted, all of its resources and data will
              also be permanently deleted. Please enter your password to confirm
              you would like to permanently delete your account.
            </DialogDescription>
            <Form
              method="delete"
              action={usersPath()}
              options={{
                preserveScroll: true,
              }}
              onError={() => passwordInput.current?.focus()}
              resetOnSuccess
              className="space-y-6"
            >
              {({ resetAndClearErrors, processing, errors }) => (
                <>
                  <div className="grid gap-2">
                    <Label htmlFor="password_challenge" className="sr-only">
                      Password
                    </Label>

                    <Input
                      id="password_challenge"
                      type="password"
                      name="password_challenge"
                      ref={passwordInput}
                      placeholder="Password"
                      autoComplete="current-password"
                    />

                    <InputError messages={errors.password_challenge} />
                  </div>

                  <DialogFooter>
                    <DialogClose
                      className={buttonVariants({ variant: "secondary" })}
                      onClick={() => resetAndClearErrors()}
                    >
                      Cancel
                    </DialogClose>

                    <Button
                      variant="destructive"
                      disabled={processing}
                      type="submit"
                    >
                      Delete account
                    </Button>
                  </DialogFooter>
                </>
              )}
            </Form>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  )
}
